import { useEffect, useState } from 'react';

const navItems = [
  { label: '专题索引', href: '#index' },
  { label: '人物档案', href: '#profile' },
  { label: '走红脉络', href: '#timeline' },
  { label: '百科词条', href: '#wiki' },
  { label: '常见问答', href: '#faq' },
];

export default function SiteHeader() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200'
          : 'bg-background-50/60 backdrop-blur-sm border-b border-transparent'
      }`}
    >
      <div className="flex items-center justify-between h-16 md:h-20 px-4 md:px-6">
        <a href="#top" className="flex items-center gap-3 cursor-pointer">
          <span className="w-10 h-10 md:w-11 md:h-11 flex items-center justify-center rounded-full bg-primary-500 text-background-50 font-heading text-lg font-bold">
            玩
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-heading text-lg md:text-xl font-bold tracking-wide text-foreground-950">玩偶姐姐</span>
            <span className="mt-1 text-[11px] tracking-[0.28em] text-secondary-700 uppercase">人物专题合集</span>
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-1">
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className="px-3 lg:px-4 py-2 text-sm text-foreground-700 hover:text-accent-700 transition-colors cursor-pointer whitespace-nowrap"
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          <a
            href="#index"
            className="px-5 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            看目录索引
          </a>
        </div>

        <button
          type="button"
          aria-label="展开菜单"
          onClick={() => setOpen((v) => !v)}
          className="md:hidden w-10 h-10 flex items-center justify-center rounded-md border border-background-300 text-foreground-800 cursor-pointer"
        >
          <i className={open ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'}></i>
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-background-200 bg-background-50 px-4 py-3">
          <nav className="flex flex-col">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={() => setOpen(false)}
                className="py-3 text-sm text-foreground-700 border-b border-background-100 last:border-none cursor-pointer"
              >
                {item.label}
              </a>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}